import { PageHeader } from '@orientamos/ui'
import { IntakeForm } from '@features/intake'

export default function IntakeNewPage() {
  return (
    <div>
      <PageHeader
        title="Nueva Orden de Contrato"
        description="Ingresa la informacion del cliente y la propiedad para crear una nueva orden"
        breadcrumbs={[
          { label: 'Inicio', href: '/' },
          { label: 'Ordenes de Contrato', href: '/intakes' },
          { label: 'Nueva Orden' },
        ]}
      />

      <IntakeForm />
    </div>
  )
}
